/**
 * TTS 语音合成公开配置 API
 * 获取公开的 TTS 服务商、音色列表与积分扣除规则
 */

import axiosInstance from "../services/axiosConfig";
import { API_PATHS, STORAGE_KEYS } from "./config";
import Logger from "../utils/logger";

/**
 * 从本地缓存获取 TTS 配置
 */
export const getCachedTtsConfig = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(STORAGE_KEYS.TTS_PUBLIC_CONFIG) || "null");
    return cached && typeof cached === "object" ? cached : null;
  } catch (error) {
    Logger.warn("读取 TTS 配置缓存失败", error);
    return null;
  }
};

/**
 * 从服务器拉取公开的 TTS 配置并更新缓存
 * @returns {Promise<object>}
 */
export const getPublicTtsConfig = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_PATHS.BASE_API_URL}${API_PATHS.TTS.GET_PUBLIC_CONFIG}`
    );

    if (response?.success && response.data) {
      try {
        localStorage.setItem(STORAGE_KEYS.TTS_PUBLIC_CONFIG, JSON.stringify(response.data));
      } catch (error) {
        Logger.warn("写入 TTS 配置缓存失败", error);
      }
    }

    return response;
  } catch (error) {
    Logger.error("获取公开 TTS 配置异常", error);
    const cached = getCachedTtsConfig();
    return { success: false, data: cached };
  }
};
